import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  header: {
    padding: "10px 20px",
  },
  headerToolbar: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  toolbar: {
    padding: "10px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  crudButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  content: {
    padding: "10px 20px",
  },
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  graphContainer: {
    height: 310,
    position: "relative",
  },
  selectHeader: {
    padding: "2rem 1rem 0 1rem",
  },
  wrapper: {
    padding: "2rem 1rem",
    backgroundColor: "white",
    borderRadius: "10px",
  },
  noDataMessage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  toggleWrapper: {
    display: "inline-flex",
    justifyContent: "end",
  },
  navLogoWrapper: {
    height: 74,
    display: "flex",
    alignItems: "left",
    paddingTop: 3,
    flexDirection: "column",
    border: "none",
    background: "none",
  },
  navLogo: {
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    height: "70px",
    width: "90%",
  },
  logo: {
    padding: 5,
    width: 180,
    height: 70,
  },
  defaultLogo: {
    width: "100px",
    marginLeft: 25,
  },
  root1: {
    width: "100%",
    display: "inline",
  },
  inputDatePicker: {
    marginBottom: "8px",
  },
}));
